import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { MsalWrapperContext } from "../../redux/actions/authActions";

function Navigation() {
  const msalWrapper = useContext(MsalWrapperContext);
  const user = useSelector((state) => state.user);

  useEffect(() => {}, []);

  return (
    <div>
      <nav
        id="navigation"
        className="main-navigation megadropdown auto-highlight"
      >
        <ul id="nav_list" className="top-level-nav">
          {/* <li className="nav-item">
            <a href="/about.html" className="first-level-link">
              <span
                className="ca-gov-icon-info-bubble"
                aria-hidden="true"
              ></span>
              Systems
            </a>
            <div className="sub-nav">
              <div className="second-level-nav flex with-border">
                <a href="https://evq.dtsc.ca.gov" className="second-level-link">
                  <span className="ca-gov-icon-globe" aria-hidden="true"></span>
                  eVQ
                  <div className="link-description">
                    DTSC’s Electronic Verification Questionnaire (eVQ) System
                  </div>
                </a>
                <a
                  href="https://evq.dtsc.ca.gov"
                  className="second-level-link"
                  target="_blank"
                >
                  <span
                    className="ca-gov-icon-cloud-download"
                    aria-hidden="true"
                  ></span>
                  Treated Wood Waste
                  <div className="link-description">
                    Download or clone State Template on GitHub{" "}
                  </div>
                </a>
                <a href="/sample/" className="second-level-link">
                  <span className="ca-gov-icon-gears" aria-hidden="true"></span>
                  Transporter Quarterly Report
                  <div className="link-description">
                    View example modules and description of their usage
                  </div>
                </a>
              </div>
            </div>
          </li> */}

          <li className="nav-item">
            <Link to="/search" className="first-level-link">
              <span
                className="ca-gov-icon-search-right"
                aria-hidden="true"
              ></span>
              Handler Search
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/reports" className="first-level-link">
              <span className="ca-gov-icon-clipboard" aria-hidden="true"></span>
              Reports
            </Link>
          </li>
          <li className="nav-item">
            <a
              href="https://dtsc.ca.gov/apply-for-hazardous-waste-epa-id-number"
              className="first-level-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="ca-gov-icon-info" aria-hidden="true"></span>
              ID Number
            </a>
          </li>
          {!user.isAuth ? (
            <li
              className="nav-item"
              id="nav-item-search"
              onClick={() => msalWrapper.onSignIn()}
            >
              <button className="first-level-link">
                <span className="ca-gov-icon-person" aria-hidden="true"></span>
                Log In
              </button>
            </li>
          ) : (
            <React.Fragment>
              <li className="nav-item nav-profile-menu">
                <Link to="/profile" className="first-level-link">
                  <span
                    className="ca-gov-icon-person"
                    style={{}}
                    aria-hidden="true"
                  />
                  {user.account.name}
                </Link>
              </li>
              <li
                className="nav-item nav-logout-menu"
                onClick={() => msalWrapper.onSignOut()}
              >
                <a className="first-level-link">
                  <span className="ca-gov-icon-lock" aria-hidden="true" />
                  Log Out
                </a>
              </li>
            </React.Fragment>
          )}
        </ul>
      </nav>
    </div>
  );
}

export default Navigation;
